import { useEffect, useRef } from "react";
import { subscribeToPush } from "../utils/pushSubscription";

/**
 * Garante que o browser esteja subscrito ao push sempre que a permissão
 * já tiver sido concedida (ex: sessão anterior). Roda uma única vez.
 */
export function usePushSubscription() {
  const tried = useRef(false);

  useEffect(() => {
    if (tried.current) return;
    tried.current = true;

    if (typeof Notification === "undefined") return;
    if (Notification.permission !== "granted") return;

    subscribeToPush().catch(() => {});
  }, []);
}
